var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaZipLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2991",
    "data-name": "Group 2991",
    transform: "translate(-384 -1280)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_748",
    "data-name": "Rectangle 748",
    width: 40,
    height: 40,
    transform: "translate(384 1280)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2985",
    "data-name": "Group 2985",
    transform: "translate(57.628 -40.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file",
    transform: "translate(336.772 1328.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M15,2H6.444A2.444,2.444,0,0,0,4,4.444V24a2.444,2.444,0,0,0,2.444,2.444H21.111A2.444,2.444,0,0,0,23.555,24V10.555Z",
    transform: "translate(-4 -2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M13,2v8.555h8.555",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "ZIP",
    transform: "translate(341.063 1347.459)",
    fill: "#0d0d0d",
    fontSize: 8,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ZIP"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaZipLargeIcon);
export default __webpack_public_path__ + "static/media/media-zip-large-icon.81e7558ea102d794b1d008b2fca9daf2.svg";
export { ForwardRef as ReactComponent };